"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Shop = function Shop(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M19.895 9.966a2.21 2.21 0 01-3.905-.164 2.208 2.208 0 01-3.99 0 2.208 2.208 0 01-3.989 0 2.21 2.21 0 01-3.906.164A1.802 1.802 0 014.04 8.35l1.336-3.092c.2-.461.655-.759 1.157-.758h10.936c.503 0 .958.297 1.158.758l1.336 3.092c.234.518.21 1.118-.067 1.616zM7.781 15.75a.156.156 0 01-.157-.156v-.938c0-.086.07-.156.157-.156h8.44c.086 0 .156.07.156.156v.938c0 .086-.07.156-.157.156H7.78zm-1.718-4.063h.625c.173 0 .313.14.313.313v3.75a.625.625 0 00.625.625h8.749c.345 0 .625-.28.625-.625V12c0-.173.14-.313.313-.313h.625c.172 0 .312.14.312.313v6.25A1.25 1.25 0 0117 19.5H7a1.25 1.25 0 01-1.25-1.25V12a.313.313 0 01.313-.313z"
  }));
};

var _default = (0, _react.forwardRef)(Shop);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Shop, "Shop", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Shop.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Shop.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();